export const PROGRESS_BAR_COLORS = {
  green: {
    bg: "#25C660",
    color: "black",
  },
  yellow: {
    bg: "#FEFCBF",
    color: "black",
  },
  orange: {
    bg: "#F59E0B",
    color: "black",
  },
  red: {
    bg: "#E40133",
    color: "black",
  },
};

export const AMBER_COLORS = {
  50: "#fef3c7",
  100: "#fde68a",
  200: "#fcd34d",
  600: "#d97706",
  700: "#b45309",
};

export const BADGE_COLORS = {
  green: {
    bg: "#C6F6D5",
    color: "#22543D",
  },
  yellow: {
    bg: "#FEFCBF",
    color: "#744210",
  },
  red: {
    bg: "#FED7D7",
    color: "#822727",
  },
};

export const getProgressBarColors = (percentage: number | undefined) => {
  if (percentage === undefined || percentage === Infinity) {
    return PROGRESS_BAR_COLORS.green;
  }
  if (percentage === 100) {
    return PROGRESS_BAR_COLORS.green;
  }
  if (percentage >= 50) {
    return PROGRESS_BAR_COLORS.orange;
  }
  return PROGRESS_BAR_COLORS.red;
};

export const getBadgeColors = (percentage: number | undefined) => {
  if (percentage === undefined || percentage === Infinity) {
    return BADGE_COLORS.green;
  }
  if (percentage === 100) {
    return BADGE_COLORS.green;
  }
  if (percentage >= 50) {
    return BADGE_COLORS.yellow;
  }
  return BADGE_COLORS.red;
};

export const BADGE_CONFIGS = {
  coverage: {
    label: (value: number) => `${value}% Part Coverage`,
    tooltip:
      "Percentage of parts from your order that this supplier can supply (regardless of quantity).",
  },
  fulfilled: {
    label: (value: number) => `${value}% Complete Fulfillment`,
    tooltip:
      "Percentage of parts that this supplier can fully fulfill with the required quantity.",
  },
  quantity: {
    label: (value: number) => `${value}% Quantity Coverage`,
    tooltip:
      "Percentage of your total quantity requirement that this supplier can fulfill (including partial matches).",
  },
};

export const getBadgeClassName = (fontSize = ".6rem") => ({
  fontSize,
  fontWeight: "900",
  borderRadius: "full",
  boxShadow: "0 0 0.2rem rgba(0, 0, 0, 0.12)",
  px: 3,
  py: 0.5,
  textTransform: "none",
  fontFamily: "'Nunito','Inter', sans-serif",
  sx: {
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },
});
